import { render, staticRenderFns } from "./overdue.vue?vue&type=template&id=242d418b&scoped=true&"
import script from "./overdue.vue?vue&type=script&lang=js&"
export * from "./overdue.vue?vue&type=script&lang=js&"
import style0 from "./overdue.vue?vue&type=style&index=0&id=242d418b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242d418b",
  null
  
)

export default component.exports